import React from "react";
import Icon from "../IconsSelector";
import * as S from "./DiscountOverlay.styles";

interface IDiscountOverlay {
  sod?: number,
  sfd?: number,
  per_off?: number,
  pd?: number,
  od?: number,
  pc?: string,
}

const  OffersListItem = props => {
  const { 
      iconName = 'Lighting',
      discountName = 'Discount',
      discountDesc = '',
      discountPrice = '',
      tagBgColor = '#fbf2ff',
      tagNameColor = '#9d3de8',
      iconWidth = '',
      iconHeight = '',
      iconColor = '#9d3de8',
      margin = ''
   } = props;

  return(
      <S.OffersListItem>
          <S.ItemRow>
              <S.DiscountTagCont bgColor={tagBgColor}>
                  <S.Icon margin={margin}>
                    <Icon name={iconName} styleProps={{ height: iconHeight, width: iconWidth, fill: iconColor }} />
                  </S.Icon>
                  <S.DiscountTxt color={tagNameColor}>{discountName}</S.DiscountTxt>
              </S.DiscountTagCont>
              <S.PreAppliedTxt>PRE - APPLIED</S.PreAppliedTxt>
          </S.ItemRow>
          <S.ItemRow marginTop={'9px'}>
              <S.DiscountDesc>{discountDesc}</S.DiscountDesc>
              <S.DiscountPrice>{`₹${discountPrice}`}</S.DiscountPrice>
          </S.ItemRow>
      </S.OffersListItem>
  );
}

const DiscountOverlayUI: React.FC<IDiscountOverlay> = ({
  sod = 0,
  sfd = 0,
  per_off = 0,
  pd = 0,
  od = 0,
  pc = "",
}) => {
  let amount = sfd + sod + od + pd;
  return (
    <S.DiscountOverlayWrapper>
      <S.DiscountHeader>
        <div className="cabName">Offers Applied</div>
        <div className="">
        {per_off && (
            <div className="priceDtl posRel">
              <div className="discount">
                <p className="text">{`${per_off}% off`}</p>
                <div className="circle"></div>
              </div>
              <div className="shape"></div>
              <div className="amount">
                <span className="giRupee">₹</span>
                {amount}
              </div>
            </div>
          )}
        </div>
      </S.DiscountHeader>
      {!!sod && <OffersListItem discountDesc="Special discount applicable on this Car" discountPrice={sod} />}
      {!!pd && <OffersListItem discountName="PROMO" tagNameColor="#ff6d38" tagBgColor="#fff2ed" discountDesc="Goibibo discount on this booking!" discountPrice={pd} iconName={"Offer"} iconColor={"#ff6d38"} margin={"-10px 0 0 -10px"} />}
      {!!sfd && <OffersListItem discountDesc="goDeal" discountPrice={sfd} />}
      {!!od && <OffersListItem discountDesc="Limited Period Discount" discountPrice={od} />}
    </S.DiscountOverlayWrapper>
  );
};

export default DiscountOverlayUI;
